import * as React from "react";

export const useIsFocused = () => {
    const [isFocused, setIsFocused] = React.useState(false);
    const [setFocus, setBlur] = React.useMemo(() => [() => setIsFocused(true), () => setIsFocused(false)], []);
    return { isFocused, setFocus, setBlur };
};
